//
//
//
//
//
//

export default {
  name: 'ConsumptionReportKPI'
};